module.exports = __webpack_public_path__ + "static/media/battery.985eb3c0.svg";